import { Controller } from "@hotwired/stimulus";

export class AgendaItemFormController extends Controller {
  static targets = ["scheduledField", "checkpointSelect", "existingForm", "newForm", "itemTypeRadio"];
  static values = {
    hasExisting: Boolean
  };

  connect() {
    this.toggleForms();
    this.updateScheduledField();
  }

  toggleForms() {
    const checkedRadio = this.itemTypeRadioTargets.find(radio => radio.checked);
    const selectedValue = checkedRadio?.value;

    if (selectedValue === "existing") {
      if (this.hasExistingFormTarget) this.existingFormTarget.classList.remove("d-none");
      if (this.hasNewFormTarget) this.newFormTarget.classList.add("d-none");
    } else {
      if (this.hasExistingFormTarget) this.existingFormTarget.classList.add("d-none");
      if (this.hasNewFormTarget) this.newFormTarget.classList.remove("d-none");
    }
  }

  updateScheduledField() {
    if (!this.hasCheckpointSelectTarget || !this.hasScheduledFieldTarget) return;

    const select = this.checkpointSelectTarget;
    const selectedOption = select.options[select.selectedIndex];
    const existingScheduled = selectedOption?.dataset?.scheduled;
    const fieldWrapper = this.scheduledFieldTarget.closest(".FormControl");

    if (existingScheduled) {
      // Checkpoint already has a schedule - hide the field
      if (fieldWrapper) {
        fieldWrapper.style.display = "none";
      }
      this.scheduledFieldTarget.removeAttribute("required");
    } else {
      // Checkpoint needs a schedule - show the field
      if (fieldWrapper) {
        fieldWrapper.style.removeProperty("display");
      }
      this.scheduledFieldTarget.setAttribute("required", "required");
    }
  }
}
